import { IUserdataType } from "@/types/GlobalTypes";
import { onlyUnique } from "./arrays";
import { gameIsVariant, getBasePcode } from "./gamePcode";

//Used in filterBaseGameFavourites
function forceRemoveFavourite(userdata: IUserdataType, pcode: string): void {
	const fetchPostData = {
		nickname: userdata.user.nickname,
		operatorId: userdata.user.operatorId,
		properties: "remove",
		game: pcode
	};

	fetch("/games/favorites/update", {
		credentials: "same-origin",
		method: "POST",
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json"
		},
		body: JSON.stringify(fetchPostData)
	})
		.then(res => res.json())
		.then(() => { //_data
			console.log("tF remove " + pcode);
		});
}

function filterBaseGameFavourites(userdata: IUserdataType, favouritedGames: string[]) {
	const gameVariants: string[] = [];

	const newList = favouritedGames.map(pcode => {
		if (gameIsVariant(pcode))
			gameVariants.push(pcode);

		return getBasePcode(pcode);
	});

	const filteredFavourites = newList.filter(onlyUnique);

	if (gameVariants.length === 0) return filteredFavourites;

	//Removes gameVariants from server
	if (window.location.href.indexOf("localhost") < 0)
		gameVariants.forEach(pcode => {
			forceRemoveFavourite(userdata, pcode);
		});

	return filteredFavourites;
}

export {
	filterBaseGameFavourites,
	forceRemoveFavourite
}